import clsx from "clsx";
import { forwardRef } from "react";

import * as styles from "../program-box.css";
import { ProgramCover } from "../program-cover/program-cover";
import { BoxProps } from "../types";

type ChannelBoxProps = BoxProps & {
  "data-position"?: number;
};

export const ChannelBox = forwardRef<HTMLDivElement, ChannelBoxProps>(
  function ForwardRefProgramBox(
    {
      "data-testid": dataTestId = "channel-box",
      "data-focused": dataFocused,
      "data-position": dataPosition,
      focused,
      logoUrl,
      coverImageUrl,
      className,
      children,
    },
    ref,
  ) {
    return (
      <div
        className={clsx([
          styles.channelBox,
          focused && styles.channelBoxFocused,
        ])}
        ref={ref}
        data-testid={dataTestId}
        data-focused={dataFocused}
        data-position={dataPosition}
      >
        {children ? <div className={styles.lock}>{children}</div> : null}
        <ProgramCover
          ref={ref}
          focused={focused}
          logoUrl={logoUrl}
          coverImageUrl={coverImageUrl}
          kind="channel"
          className={className}
          data-testid={`${dataTestId}-cover`}
          data-focused={focused}
        />
      </div>
    );
  },
);
